import { writable } from 'svelte/store';
import collect from 'collect.js';
import config from '@/config.js';
// Models
import SportClassification from '@/Models/SportClassification.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	let _store;
	let meta;

	const { subscribe, set, update } = writable(collect());

	subscribe((current) => (_store = current));

	const methods = {
		getPagination() {
			return meta && meta.pagination;
		},

		getClassificationsForSport(sportId, pagination = null) {
			if (!config.SPORT_ENABLED) return;

			const classification = new SportClassification();
			classification.resourceUrl = () => {
				return `${classification.baseUrl()}/sports/${sportId}/classifications`;
			};

			let results = pagination ? classification.paginate(pagination.size, pagination.number) : classification.get();
			return results
				.then((result) => {
					meta = result.meta;
					set(collect(result.data));
				})
				.catch((e) => {
					console.error(e);
				});
		},

		saveClassificationMarketGroupSet(sportId, classificationId, market_group_set_id = null) {
			if (!config.SPORT_ENABLED) return;

			let classification = new SportClassification();
			classification = classification.hydrate({
				id: null,
				classification: { id: classificationId },
				sport: { id: sportId },
				type: 'sport_classifications'
			});
			return classification
				.updateMarketGroupSet({
					market_group_set_id
				})
				.then((results) => {
					this.getClassificationsForSport(sportId);
					return results;
				});
		},

		updateClassificationMarketGroupSet(classificationId, market_group_set_id = null) {
			if (!config.SPORT_ENABLED) return;

			let classification = _store.firstWhere('classification.id', classificationId);
			return classification
				.updateMarketGroupSet({
					market_group_set_id
				})
				.then((results) => {
					this.getClassificationsForSport(classification.sport.id);
					return results;
				});
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
